import { Box, Button, Dialog, Typography } from "@mui/material"
import { LoadingButton } from "@mui/lab"
import { FC } from "react"

interface Props {
    name: string
    pending?: boolean
    processing?: boolean
    onConfirm: () => void
    close: () => void
}

const RemoveCollaboratorDialog: FC<Props> = ({ name, pending, processing, onConfirm, close }) => (
    <Dialog open onClose={close} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
        <Box sx={{ p: 3 }}>
            <Typography sx={{ fontWeight: 800, fontSize: 16, mb: 1 }}>
                {pending ? 'Revoke Invitation' : 'Remove Collaborator'}
            </Typography>
            <Typography sx={{ fontSize: 13, color: 'text.secondary', mb: 3 }}>
                {pending
                    ? `Are you sure you want to revoke the invitation sent to ${name}?`
                    : `Are you sure you want to remove ${name} from this property?`}
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                <Button onClick={close} disabled={processing} variant="outlined" color="inherit" sx={{ textTransform: 'none' }}>
                    Cancel
                </Button>
                <LoadingButton
                    onClick={onConfirm}
                    loading={processing}
                    variant="contained"
                    color="error"
                    sx={{ textTransform: 'none' }}
                >
                    {pending ? 'Revoke' : 'Remove'}
                </LoadingButton>
            </Box>
        </Box>
    </Dialog>
)

export default RemoveCollaboratorDialog
